/**
 * Redux utility function to combine multiple reducers into a single rootReducer.
 */
import { combineReducers } from "redux";

/**
 * Importing the coinsReducer responsible for managing the state of cryptocurrency coins.
 */
import coinsReducer from "./coinsReducer";

/**
 * Root reducer that combines all individual reducers into a single state tree.
 * Each key in the state object corresponds to a different reducer's slice.
 * The keys match the names given when creating the Redux store.
 */
const reducers = combineReducers({
  coins: coinsReducer, // The 'coins' key holds the state managed by the coinsReducer
});

export default reducers;
